import { apiSlice } from './apiSlice';
import { GSTROUTES_URL } from '../constants';

export const gstApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Generate GSTR-1 report
    generateGSTR1Report: builder.mutation({
      query: (data) => ({
        url: `${GSTROUTES_URL}/generate`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['GSTR1'],
    }),

    // ✅ Get GSTR-1 report by vendorId and period
    getGSTR1Report: builder.query({
      query: ({ vendorId, period }) => ({
        url: `${GSTROUTES_URL}/report/${vendorId}/${period}`,
      }),
      providesTags: ['GSTR1'],
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGenerateGSTR1ReportMutation,
  useGetGSTR1ReportQuery,
} = gstApiSlice;
